import { ApiError } from '@myrentalmate/api-client';

/** Words to show a person for a failed request. Business-rule refusals explain themselves. */
export function apiErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const detail = (error.body as { detail?: unknown } | undefined)?.detail;
    if (typeof detail === 'string') return detail;
    // A rule from our own validators (see common/contact.py) is written for people.
    if (Array.isArray(detail)) {
      const rule = (detail as { type?: string; msg?: string }[]).find(
        (d) => d.type === 'value_error',
      );
      if (rule?.msg) return rule.msg.replace(/^Value error, /, '');
    }
    if (error.status === 422)
      return 'Please check the highlighted form for missing or invalid details.';
    if (error.status === 403) return "You don't have permission to do that.";
  }
  return 'Something went wrong. Please try again.';
}

/** The API's refusal when someone must set up two-factor before doing anything else. */
export function isMfaEnrollmentRequired(error: unknown): boolean {
  return (
    error instanceof ApiError &&
    error.status === 403 &&
    (error.body as { detail?: unknown } | undefined)?.detail === 'mfa_enrollment_required'
  );
}
